<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Modification de l'agence <strong>{{agency.nom_agence}}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="ville">Ville</label>
              <b-form-input type="text" v-model="agency.ville" placeholder="Ville"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="commune">Commune</label>
              <b-form-input type="text" v-model="agency.commune" placeholder="Commune"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="telephone">Téléphone</label>
              <b-form-input type="text"  v-model="agency.telephone" placeholder="Telephone"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="contact">Nom *</label>
              <b-form-input type="text"  v-model="agency.nom_agence" placeholder="Contact, Site Web,Adresse ... "></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12">
              <label for="entite_id">Entité</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="agency.entite_id" disabled>
              </b-form-select>
            </b-col>
            <b-col md="12">
              <label for="description">Description</label>
               <textarea id="description" placeholder="Description" v-model="agency.description" rows="3" max-rows="6" class="form-control"></textarea>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('agence-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" size="sm" variant="danger" @click="goBack"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      agency:{
            ville: '',
            commune: '',
            telephone: '',
            nom_agence: '',
            entite_id: '',
            description: '',
             _method:'PUT'
      },
      entities:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    goBack() {
      this.$router.go(-1)
    },
    async put(){     
        this.response =await this.$store.dispatch('agency/put_agency',{id:this.$route.params.id,agency:this.agency})
        this.showAlert()
    },
    async displayAgency(){
        let response = await this.$store.dispatch('agency/show_agency',this.$route.params.id)
        this.agency.ville= response.ville,
        this.agency.commune= response.commune,
        this.agency.telephone= response.telephone,
        this.agency.nom_agence= response.nom_agence,
        this.agency.entite_id= response.entite_id,
        this.agency.description=response.description
    },
    async get_all_entities(){
      await this.$store.dispatch('entity/get_all_authentites',this.serverParams).then(()=>{
        return this.entities = store.getters['entity/rows'];    
      })
      this.entities.forEach((element)=>{
          this.options.push({
            value:element.id,
            text:element.typeentite_libelle.toUpperCase()+' : '+element.nom_commercial.toUpperCase(),
          })
      })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
    this.displayAgency()
    this.get_all_entities()
  }
}
</script>
